import React from 'react';
import { Flex, Image, Text, Icon, useColorMode } from '@chakra-ui/react';
import { FiExternalLink } from 'react-icons/fi';

const BlockChainRecord = ({ mint_tx_id }) => {
  const { colorMode } = useColorMode();
  return (
    <Flex id="address" py="25px" flexDirection="column">
      <a
        href={`https://explorer.stacks.co/txid/${mint_tx_id}?chain=${
          process.env.NEXT_PUBLIC_ENV === 'production' ? 'mainnet' : 'testnet'
        }`}
        target="_blank"
        rel="noreferrer"
      >
        <Flex
          w="250px"
          bg={colorMode === 'dark' ? '#1C1C1C' : '#F7F7F7'}
          p="7px 15px"
          borderRadius={8}
          borderWidth={colorMode === 'dark' ? 0 : 1}
          borderColor={colorMode === 'dark' ? '#333' : '#eee'}
          color="#6B6B70"
          justifyContent="space-between"
          cursor="pointer"
        >
          <Flex alignItems="center">
            <Image src="/images/stacks-stx-logo.svg" w="18px" h="18px" alt="" />
            <Text fontSize="14px" fontWeight="500" ml="15px">
              Blockchain Record
            </Text>
          </Flex>

          <Icon as={FiExternalLink} fontSize="17px" color="#7a8087" />
        </Flex>
      </a>
    </Flex>
  );
};

export default BlockChainRecord;
